import React, {useEffect, useState} from 'react';
import cn from 'classnames';

import style from './CustomTooltip.module.scss';

const CustomTooltip = ({text, position = 'bottom', displayed, className: externalClassName, params = {}}) => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (displayed) return setVisible(true);
        setVisible(false);
    }, [displayed]);

    const className = cn(style.tooltip, style[params.position || position], externalClassName, {
        [style.displayed]: displayed,
        [style.visible]: visible,
    });
    return <div className={className}>{text}</div>;
};

export default CustomTooltip;
